import { Component } from '@angular/core';
import { NavController, NavParams,
        ToastController,AlertController,LoadingController  } from 'ionic-angular';
import { HttpClient,HttpHeaders,HttpResponse } from '@angular/common/http';
import { Storage } from '@ionic/storage';

//types
import { LoginInfo,ProfileViewModel } from '../model/types';

//service
import { UserService  } from '../service/user_service';
import { AppSharedService  } from '../service/app_shared';

//page
import { MenuPage } from '../menu/menu'
import { LoginPage } from '../login/login'

@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {
  
  //constructor
  constructor(public navCtrl: NavController
             ,public navParams: NavParams
            ,private userService:UserService
            ,private toastController:ToastController
            ,private alertCtrl:AlertController
            ,private http: HttpClient
            ,private appSharedService:AppSharedService
            ,private storage: Storage
            ,private loadingCtrl : LoadingController
          ) { 
    //initialize class level variable
    userService.getUserDetails()     
  }
  goToHome(){
    this.navCtrl.popToRoot();
    this.navCtrl.setRoot(MenuPage)
  }
  //update profile
  
  UpdateProfile(){
   
    if(this.userService.userDetails.CustomerName.trim()==""){
       this.toastController.create({ message: "Please enter your name.", duration: 2000, showCloseButton: true }).present();
    }
    else if(this.userService.userDetails.Contact.trim()==""){
     this.toastController.create({ message: "Mobile number is required.", duration: 2000, showCloseButton: true }).present();
    }
    else if(this.userService.userDetails.Password.trim()==""){
     this.toastController.create({ message: "Password is required.", duration: 2000, showCloseButton: true }).present();
    }
    else if(this.userService.userDetails.LocationId==0){
      this.toastController.create({ message: "Please select location.", duration: 2000, showCloseButton: true }).present();
    } 
    else{
      this.UpdateProfileDB();
    }
 }
 // call service to update profile
 UpdateProfileDB(){
   
  //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

  this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {
  
    // set view model
    if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
        var reg:ProfileViewModel={
          Email:this.userService.userDetails.Email,
          CustomerName:this.userService.userDetails.CustomerName,
          Password:this.userService.userDetails.Password,
          PhoneNumber:this.userService.userDetails.Contact,
          PostalCode:this.userService.userDetails.PostalCode,
          LocationId:this.userService.userDetails.LocationId
     }
    
    //create header
    let myheaders = new HttpHeaders();
    myheaders =myheaders.append('Content-Type', 'application/json');
    myheaders =myheaders.append('token', userinfo.Token);
    
    //create url
    var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlUpdateProfileDetails);
    
    //show the loader
    loading.present();

    // do the service call
    this.http.post(url, reg, {headers : myheaders,observe: 'response'})
      .subscribe((res: HttpResponse<any>) => {   
          if(res.status==200){            
            let message=this.appSharedService.getHttpResponseMessage(res,'Your profile updated succesfully!');
            loading.dismiss();

            // show success message
            this.alertCtrl.create({
                title: 'Success',
                subTitle: message,
                buttons: ['OK']
              }).present();

            this.storage.remove("bz_user_02");
            if(userinfo.LocationId!=this.userService.userDetails.LocationId){
              this.storage.remove("bz_cart_02");
            }

            userinfo.LocationId=this.userService.userDetails.LocationId;
            userinfo.LocationName=this.userService
                                      .userDetails
                                      .LocationDetails
                                      .find(item=>item.locationId==this.userService.userDetails.LocationId)
                                      .locationName;
            this.storage.set("bz_user_02",userinfo);
            }
            else if(res.status==204){       
              
              loading.dismiss();
              this.storage.clear();
              this.navCtrl.popToRoot();
              this.navCtrl.setRoot(LoginPage);

            }
            else{        
              
              let message=this.appSharedService.getHttpResponseMessage(res,'There is problem with profile update. please try after sometime!');
              loading.dismiss();
              
              // show error message
                this.alertCtrl.create({
                title: 'Error!',
                subTitle: message,
                buttons: ['OK']
              }).present();
          }
      });
    }
  });
 }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts